export function range(length: number, startFrom?: number, step = 1): number[] {
  const base = [...Array(length).keys()];

  if (!startFrom) {
    return base;
  }

  const start = startFrom || 0;

  return base.map((v) => v * step + start);
}

export function uniqueByKey<T = { id: string | number }>(
  array: T[],
  key = 'id' as keyof T
): T[] {
  const result: T[] = [];
  const map = new Map();

  for (const item of array) {
    if (map.has(item[key])) {
      continue;
    }

    map.set(item[key], true);
    result.push(item);
  }

  return result;
}

export function byKeyComparator<T>(key: keyof T) {
  return function (a: T, b: T) {
    if (a[key] < b[key]) {
      return -1;
    } else if (a[key] > b[key]) {
      return 1;
    } else {
      return 0;
    }
  };
}
